export default {
  // 云采损耗统计分页查询，基差订单按主单汇总。
  selectLossReportByPage: '/ygsjzs/yxcPurchaseReport/selectLossReportByPage',
  // 导出当前筛选范围内的全部损耗统计。
  exportLossReport: '/ygsjzs/yxcPurchaseReport/exportLossReport',
  // 审批锁价订单
  approvalYxcPriceOrder: '/ygsjzs/yxcPriceOrder/approvalYxcPriceOrder',

  // 删除锁价订单
  deleteYxcPriceOrder: '/ygsjzs/yxcPriceOrder/deleteYxcPriceOrder',

  // 新增锁价订单
  insertYxcPriceOrder: '/ygsjzs/yxcPriceOrder/insertYxcPriceOrder',

  // 修改锁价订单
  updateYxcPriceOrder: '/ygsjzs/yxcPriceOrder/updateYxcPriceOrder',
  // 审批通过后补录外部点价单编号
  updateYxcPriceOrderNo: '/ygsjzs/yxcPriceOrder/updateYxcPriceOrderNo',

  // 关联提货单
  insertYxcPickupOrderByLockedList: '/ygsjzs/yxcPickupOrder/insertYxcPickupOrderByLockedList',

  // 查询锁价订单详情
  selectYxcPriceOrderByOrderId: '/ygsjzs/yxcPriceOrder/selectYxcPriceOrderByOrderId',
  // 分页查询锁价订单列表
  selectYxcPriceOrderByPage: '/ygsjzs/yxcPriceOrder/selectYxcPriceOrderByPage',
  // 导出
  exportYxcPriceOrder: '/ygsjzs/yxcPriceOrder/exportYxcPriceOrder',
  // 基差合同点价情况表PDF
  downloadBasisContractReport: '/ygsjzs/yxcPurchaseReport/downloadBasisContractReport',
  // 散油采购合同执行表PDF
  downloadBulkPurchaseExecutionReport: '/ygsjzs/yxcPurchaseReport/downloadBulkPurchaseExecutionReport',
  // 查看订单剩余可提货数量
  selectYxcOrderNum: '/ygsjzs/yxcPickupOrder/selectOrderNum',

  // 提货日期
  updateYxcPriceOrderDate: '/ygsjzs/yxcPriceOrder/updateYxcPriceOrderDate',
  // 释放
  endYxcPriceOrderDate: '/ygsjzs/yxcPriceOrder/endYxcPriceOrderDate',

  // 修改点击数量
  updateYxcPriceNum: '/ygsjzs/yxcPriceNum/updateYxcPriceNum',
  // 修改单日提货数量
  updateYxcPriceOrderNum: '/ygsjzs/yxcPriceOrder/updateYxcPriceOrderNum',
  // 获取点价数量详情
  selectYxcPriceNumByNumId: '/ygsjzs/yxcPriceNum/selectYxcPriceNumByNumId',
  // 货权转移的接口
  insertYxcPriceOrderRes: '/ygsjzs/yxcPriceOrderResRes/insertYxcPriceOrderRes',
  approvalYxcPriceOrderRes: '/ygsjzs/yxcPriceOrderResRes/approvalYxcPriceOrderRes',
  approvalYxcPriceOrderHg: '/ygsjzs/yxcPriceOrderResRes/approvalYxcPriceOrderHg',
  txYxcHgPdf: '/ygsjzs/yxcPriceOrderResRes/txHgPdf',
  // 退回订单（订单状态为2时）
  backYxcPriceOrder: '/ygsjzs/yxcPriceOrder/backYxcPriceOrder'
}
